import React, {startTransition} from 'react';

/**
 * This component can be used to Render Components only on the client side, without breaking the ongoing hydration at Suspense Boundaries.
 */
export const ClientGate: React.FC<React.PropsWithChildren> = ({children}) => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    startTransition(() => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setMounted(true);
    });
  }, []);

  if (!mounted) {
    return null;
  }

  return <>{children}</>;
};
